<template>
  <div class="linkinput">
    <TextInput :validation="isEmail? isValidEmail : isValidHttpUrl" :name="name" :errorcont="errorcont" v-model="val" :increased="!val" :text="text" :required="required"/>
    <LinkBtn v-if="btn" @click.prevent.native="$emit('send')" class="linkinput__btn" />
  </div>
</template>

<script>
import TextInput from '@/components/TextInput.vue'
import LinkBtn from './ui/LinkBtn.vue'
export default {
  components: { TextInput, LinkBtn },
  props: {
    text: {type: String, default: 'Укажите ссылку для отправки'},
    btn: {type: Boolean, default: true},
    required: {type: Boolean, default: false},
    name: {type: String},
    isEmail: {type: Boolean, default: false},
    value: {required: true},
    errorcont: { type: Object }
  },
  methods: {
    isValidHttpUrl(str) {
      var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      if (!pattern.test(str))
        return 'Некорректная ссылка'
      return ''
    },
    isValidEmail(email) {
      if (String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ))
        return ''
      return 'Некорректный email'
    }
  },
  computed:{
    val: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    },
  },
}
</script>

<style lang="sass" scoped>
.linkinput
  display: flex
  justify-content: space-between
  align-items: flex-start
  .formlabel
    width: auto
    flex-grow: 1
  &__btn
    padding: 0
    background: none
    outline: none
    border: none
    border-radius: 5px
    margin-left: 16px
</style>